angular.module('graph').controller('ph-calendar', [
    '$scope', 'ph-core', 'ph-date-service', '$rootScope', '$cookies',
    function ($scope, $core, $date, $root, $cookies) {
        $scope.$data = {
            timezone: ($cookies.get('gputz') == 'undefined') ? 'UTC' : $cookies.get('gputz'),
            lang: ($cookies.get('gpuln') == 'undefined') ? 'en' : $cookies.get('gpuln'),
            date: $date.$now(),
            events: [],
            requests: []
        };

        $scope.calendar = {
            event: function () {
                var b = $('#calendar').fullCalendar('getDate');
                var date = b.format('YYYY-MM');
                var request = null;
                var prev = $date.$parse(date).subtract(1, 'month').format('YYYY-MM');
                var next = $date.$parse(date).add(1, 'month').format('YYYY-MM');

                if ($scope.$data.requests.indexOf(date) !== -1 &&
                    $scope.$data.requests.indexOf(prev) === -1
                ) {
                    request = prev;

                } else if ($scope.$data.requests.indexOf(date) !== -1 &&
                    $scope.$data.requests.indexOf(next) === -1
                ) {
                    request = next;
                }

                if ($scope.$data.requests.indexOf(request) === -1 && request !== null) {
                    $scope.$data.requests.push(request);
                    $scope.$request.get.calendar(request, true);
                }

            },
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listWeek'
            }
        };

        $scope.$filters = {
            unique: function (data) {
                var unique = [];

                if (typeof data !== 'undefined') {
                    for (var entry in data) {
                        data[entry].forEach(function (event) {
                            var exists = false;
                            $scope.$data.events.forEach(function (item) {
                                if (item.id === event.id && item.type === event.type) {
                                    exists = true;
                                    return false;
                                }
                            });
                            if (exists === false) {
                                unique.push(event);
                            }
                        });
                    }
                }

                return unique;
            }
        };

        $scope.init = function () {
            $scope.$data.requests.push(
                $date.$new($scope.$data.date).subtract(1, 'months').format('YYYY-MM'),
                $scope.$data.date.format('YYYY-MM'),
                $date.$new($scope.$data.date).add(1, 'months').format('YYYY-MM')
            );

            var tick = 0, obj = {
                size: $scope.$data.requests.length,
                i: tick
            };

            $scope.$data.requests.forEach(function (month) {
                $scope.$request.get.calendar(
                    month,
                    false,
                    obj
                );
            });
        };

        $scope.$request = {
            "get": {
                calendar: function (month, add, init) {
                    $core.get(
                        '/xhr/' +
                        $scope.$parent.user.id +
                        '/calendar?type=month&month=' +
                        month
                    ).then(function ($response) {
                        if ($response.data.state === 0) {
                            var result = $scope.$filters.unique(
                                $response.data.data
                            );

                            if (typeof add !== 'undefined' && add === true) {
                                $('#calendar').fullCalendar('addEventSource', result)
                            }

                            $scope.$data.events = $scope.$data.events.concat(
                                result
                            );

                            if (typeof init !== 'undefined' && (++init.i === init.size)) {
                                $('#calendar').fullCalendar({
                                    header: $scope.calendar.header,
                                    defaultDate: $scope.$data.date,
                                    timezone: $scope.$data.timezone,
                                    locale: $scope.$data.lang,
                                    navLinks: true,
                                    editable: false,
                                    eventLimit: true,
                                    events: $scope.$data.events,
                                    viewRender: $scope.calendar.event
                                });

                                $('#loader').remove();
                            }
                        }
                    });
                }
            }
        };
    }
]);
